import React, { FunctionComponent } from 'react';
import { Box, Grid, Link } from '@material-ui/core';
import specificationsAndFeaturesStyles from './specificationsAndFeaturesStyles';
import { IKeyFeature } from '../../../../../../gqlCommon/model/IVariants';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import Specifications from './specifications/Specifications';
import KeyFeatures from './keyFeatures/KeyFeatures';

export interface ISpecificationsAndFeaturesProps {
  keyFeatures: IKeyFeature[];
  engineTitle: string;
  transmissionTitle: string;
  openModal: () => void;
  brochureUrl?: string;
}

const SpecificationsAndFeatures: FunctionComponent<ISpecificationsAndFeaturesProps> = ({
  transmissionTitle,
  engineTitle,
  keyFeatures,
  openModal,
  brochureUrl,
}) => {
  const styles = specificationsAndFeaturesStyles();

  return (
    <Box data-test="customise:specificationFeaturesContent">
      <Specifications engineTitle={engineTitle} transmissionTitle={transmissionTitle} />
      <KeyFeatures keyFeatures={keyFeatures} />
      <Grid container={true} className={styles.linksContainer}>
        <Grid item={true} xs={brochureUrl ? 8 : 12}>
          <Box>
            <Link
              onClick={openModal}
              variant="caption"
              className={styles.viewSpecificationsFeaturesLink}
              data-test="customise:viewSpecificationsFeaturesLink"
            >
              <Translation id="trans__configurator__customise_page_variant_section__view_full_specs" />
            </Link>
          </Box>
        </Grid>

        {brochureUrl && (
          <Grid item={true} xs={4}>
            <Box textAlign={'right'}>
              <Link
                variant="caption"
                className={styles.brochureLink}
                href={brochureUrl}
                target={'_blank'}
                data-test="customise:link:brochure"
              >
                <Translation id="trans__configurator__customise_page_variant_section__download_brochure_link" />
              </Link>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default SpecificationsAndFeatures;
